import z from "zod";

import { StrapiMediaSchema } from "@shared/content-types/schemas/media.schema";
import { AuthorSchema } from "@shared/ui/author";

export const MediaContentSchema = z.object({
  id: z.number().int().positive(),
  location: z.string().min(1),
  media: StrapiMediaSchema,
  icon: z.enum(["location", "walk"]).default("location"),
});

export const TextContentSchema = z.object({
  id: z.number().int().positive(),
  platformIcon: StrapiMediaSchema,
  title: z.string().min(1),
  author: AuthorSchema,
  link: z.string().min(1),
});

export const MediaPostSchema = z.object({
  id: z.number().int().positive(),
  documentId: z.string().min(1),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
  publishedAt: z.string().datetime(),
  isMedia: z.boolean(),
  mediaContent: MediaContentSchema.optional().nullable(),
  textContent: TextContentSchema.optional().nullable(),
});
